import React from 'react';
import { Inbox } from 'lucide-react';

export default function EmptyState({
  icon: Icon = Inbox,
  title = 'Nothing here yet',
  description = null,
  action = null,
  className = '',
}) {
  return (
    <div className={`flex flex-col items-center justify-center py-10 px-6 text-center rounded-xl border border-white/[0.05] bg-white/[0.015] ${className}`}>
      <div className="w-10 h-10 rounded-full bg-white/[0.04] border border-white/[0.06] flex items-center justify-center mb-3 text-gray-500">
        <Icon className="w-4 h-4" />
      </div>
      <div className="text-sm text-gray-300 font-medium">{title}</div>
      {description && <div className="text-[12px] text-gray-500 mt-1 max-w-sm">{description}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
